/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

import '@oat-sa-private/ui-identity/css/main.css';
import App from './App.svelte';
import './styles/main.css';
import configurationStore from './stores/configuration';
import schoolSettings from './stores/schoolSettings';
import diagnosticSettings from './stores/diagnosticSettings';

function mountApp(target) {
    const app = new App({
        target: document.querySelector(target)
    });

    return app;
}

async function startApp () {
    await configurationStore.load();
    await schoolSettings.restoreValues();
    await diagnosticSettings.restoreValues();

    mountApp('#app');
}

startApp();

window.addEventListener('error', function (e) {
    /* eslint-disable-next-line */
    console.error(`error event: ${e.error?.message || e}`);
    return false;
 })
window.addEventListener('unhandledrejection', function (e) {
    /* eslint-disable-next-line */
    console.error(`unhandledrejection: ${e.reason}`);
})

